import React from 'react'
import { Typography, makeStyles } from '@material-ui/core'
import { styles } from './styles'

const useStyles = makeStyles(() => styles)

export const FieldLabel = ({ label, mandatory = false, cypress_id }) => {
  const classes = useStyles()

  if (mandatory) {
    return (
      <div className={classes.labelWrapper}>
        <Typography className={classes.labelText} cypress_id={cypress_id}>
          {label}
        </Typography>
        <span className={classes.mandatory}>*</span>
      </div>
    )
  } else {
    return (
      <Typography className={classes.labelText} cypress_id={cypress_id}>
        {label}
      </Typography>
    )
  }
}
